<template>
  <app-drawer
    drawer-ref="agency-drawer"
    heading="Agency details"
    :is-open="agencyDrawerStore.isOpen"
    :click-outside-allow-classes="['agencies-table']"
    :is-loading="isPending"
    @close="close"
  >
    <template #body>
      <div class="flex flex-col gap-8">
        <agency-details-card
          :agency="agency"
          :is-loading="isPending"
        />
        <agency-details-regions
          :regions="agency?.data?.country_codes"
          :is-loading="isPending"
        />
        <agency-details-identifiers :agency-id="agencyId" />
      </div>
    </template>
  </app-drawer>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAgencyDrawerStore } from '@/stores/agencies';
import { useAgencyById } from '@/services/agencies/queries';
import AgencyDetailsRegions from '@/components/agencies/AgencyDetails/AgencyDetailsRegions.vue';
import AgencyDetailsCard from '@/components/agencies/AgencyDetails/AgencyDetailsCard.vue';
import AgencyDetailsIdentifiers from '@/components/agencies/AgencyDetails/AgencyDetailsIdentifiers.vue';

const route = useRoute();
const router = useRouter();

const emit = defineEmits(['close']);
const agencyDrawerStore = useAgencyDrawerStore();
const agencyId = computed(() => agencyDrawerStore.agencyId);

const { data: agency, isPending } = useAgencyById(agencyId);

const close = () => {
  if (route.name === 'agency') {
    router.replace({ name: 'agencies' });
  }
  agencyDrawerStore.closeDrawer();
  emit('close');
};
</script>
